import React from 'react';
import ReactDOM from 'react-dom';
import commonComponents from '../common/components';
import commonHOCs from '../common/hocs';
import { components as qualComponents, api as qualApi } from '../components/qual';
import configureStore from '../store/configureStore';
import { getTranslations } from '../common/utils';


const allComponents = {
  ...commonComponents,
  ...commonHOCs,
  ...qualComponents
};

const store = configureStore();

//console.log(allComponents);

const renderComponent = (component, parentElement, props = {}) => {
  //console.log('trying to unmount component at: ', parentElement);
  //console.log('parentNode: ', ReactDOM.findDOMNode(parentElement));
  unmountComponent(ReactDOM.findDOMNode(parentElement));

  const requiredComponent = allComponents[component];


  const withTranslationsHOC = allComponents.withTranslations;

  //const reactElement = React.createElement(allComponents[component], props);

  const translatedElement = React.createElement(withTranslationsHOC(allComponents.withStore(store)(requiredComponent)), props);

  //const withStoreElement = React.createElement(allComponents.withStore(configureStore())(allComponents[component]), props);

  //console.log('Rendering translated component: ', translatedElement);

  console.log('rendering component inside: ', parentElement);


  ReactDOM.render(translatedElement, parentElement);
};

const unmountComponent = (parentElement) => {
  //console.log('unmounting: ', parentElement);
  ReactDOM.unmountComponentAtNode(ReactDOM.findDOMNode(parentElement));
};

export default {
  helpers: {
    renderComponent,
    unmountComponent,
    getTranslations
  },
  apis: {
    qual: qualApi
  }
};




// WEBPACK FOOTER //
// ./utils/reactInterface.js